import React, { useMemo, useState } from 'react';
import { experienceData } from '../../../data/experienceData';
import { projectsData } from '../../../data/projectsData';
import { skillAliases, skillsData } from '../../../data/skillsData';
import { buildSkillMap } from '../../../utils/skillMap';

const COLLAPSED_ROWS = 10;

function SkillMap() {
    const [expanded, setExpanded] = useState(false);
    const { columns, rows } = useMemo(
        () => buildSkillMap(skillsData, experienceData, projectsData, skillAliases),
        []
    );
    const visible = expanded ? rows : rows.slice(0, COLLAPSED_ROWS);

    return (
        <div className='skillmap'>
            <h3 className='skillmap__title'>Evidence map</h3>
            <p className='skillmap__hint'>
                Each dot is a role or project whose description mentions the skill. Strongest first.
            </p>

            <div className='skillmap__scroll' tabIndex={0} role='region' aria-label='Skills evidence map, scrollable'>
                <table className='skillmap__table'>
                    <caption className='sr-only'>
                        Which roles and projects mention each skill
                    </caption>
                    <thead>
                        <tr>
                            <th scope='col'>Skill</th>
                            {columns.map((column) => (
                                <th
                                    key={column.key}
                                    scope='col'
                                    className={`skillmap__col skillmap__col--${column.kind.toLowerCase()}`}
                                    title={`${column.label} (${column.detail})`}
                                >
                                    <span>{column.label}</span>
                                </th>
                            ))}
                            <th scope='col' className='skillmap__total'>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        {visible.map((row) => (
                            <tr key={row.skill}>
                                <th scope='row'>{row.skill}</th>
                                {columns.map((column) => {
                                    const hit = row.hits.has(column.key);
                                    return (
                                        <td key={column.key} className={hit ? 'is-hit' : undefined}>
                                            {hit ? (
                                                <>
                                                    <span className='skillmap__dot' aria-hidden='true' />
                                                    <span className='sr-only'>Yes: {column.label}</span>
                                                </>
                                            ) : (
                                                <span className='sr-only'>No</span>
                                            )}
                                        </td>
                                    );
                                })}
                                <td className='skillmap__total'>{row.count}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {rows.length > COLLAPSED_ROWS && (
                <button
                    type='button'
                    className='btn skillmap__toggle'
                    aria-expanded={expanded}
                    onClick={() => setExpanded((value) => !value)}
                >
                    {expanded ? 'Show fewer skills' : `Show all ${rows.length} skills`}
                </button>
            )}
        </div>
    );
}

export default SkillMap;
